module.exports = __webpack_public_path__ + "img/douyin.cb8abf70.png";